import { useMemo } from 'react';
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';

const EditLeftBar = (props) => {
    const menuList = useMemo(() => ([
        {
            key: 'matting',
            label: '智能抠图',
            icon: 'icon-mattingOutlined',
            openInNewPage: true,
            path: '/home/image_extraction'
        },
        {
            key: 'imageResize',
            label: '高清改尺寸',
            icon: 'icon-picResizeOutlined',
            path: '/home/aiEdit?menuKey=imageResize'
        },
        {
            key: 'imageFiner',
            label: 'AI超清',
            icon: 'icon-hasHDOutlined',
            newIcon: true
        },
        {
            key: 'filllight',
            label: '智能补光',
            icon: 'icon-lightIconOutlined'
        },
        {
            key: 'beautify',
            label: '模特美化',
            icon: 'icon-beautyIconOutlined'
        },
        {
            key: 'magicErase',
            label: '魔法擦除',
            icon: 'icon-magicIconOutlined'
        },
        {
            key: 'handRepair',
            label: '手部修复',
            icon: 'icon-handRepairOutlined'
        },
        {
            key: 'outpaint',
            label: 'AI扩图',
            icon: 'icon-Outpaint'
        }
    ]), [])
    const handleMenuClick = (menu) => {
        if (menu.openInNewPage) {
            const { url } = props
            window.open(url ? `${menu.path}?url=${encodeURIComponent(url)}` : menu.path, '_blank')
            return
        }

        props.onClick({ key: menu.key })
        props.setOutputMask()
    }

    return (
        <div className={styles.Sidebar}>
            <div className={styles.SidebarTop}>
                {menuList.map(menu => {
                    const isActive = props.activeKey === menu.key
                    const iconColor = isActive ? 'rgb(0, 110, 255)' : '#5b6673'
                    return (
                        <div key={menu.key} className={styles.SidebarItem} onClick={() => handleMenuClick(menu)}>
                            <div className={`${styles.SidebarItemContent} ${isActive ? styles.SidebarItemContentActive : ''}`}>
                                <Iconfont className={styles.SidebarIcon} type={menu.icon} style={{ color: iconColor }} />
                                <p>{menu.label}</p>
                                {menu.newIcon && <span className={styles.NewIcon}></span>}
                                {menu.openInNewPage && <Iconfont type="icon-newpageOutlined" className={styles.NewPageIcon} />}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default EditLeftBar
